export default __webpack_public_path__ + "static/media/radio.c8a96df5.svg";